import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export interface WithRouterProps {
  location: ReturnType<typeof useLocation>;
  navigate: ReturnType<typeof useNavigate>;
  params: ReturnType<typeof useParams>;
}

/**
 * react-router 6 dropped withRouter along with the rest of the class API.
 * This keeps the one remaining class component on props instead of rewriting
 * it. `history.push(to)` becomes `navigate(to)`; everything else is the same.
 */
const withRouter = <P extends WithRouterProps>(Component: React.ComponentType<P>) => {
  const Wrapped = (props: Omit<P, keyof WithRouterProps>) => (
    <Component
      {...(props as P)}
      location={useLocation()}
      navigate={useNavigate()}
      params={useParams()}
    />
  );
  Wrapped.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
};

export default withRouter;
